import { BASE_URL_CLIENT, BASE_URL } from "~/constants/api/base.js";

export const ORDER_UN_AUTH_URL = `${BASE_URL_CLIENT}/orders-unAuth`;
export const ORDER_AUTH_URL = `${BASE_URL_CLIENT}/orders`;
export const ORDER_BCC_URL = `${BASE_URL_CLIENT}/orders/checkout`;

export const ORDER_GET_AVAILABLE_TIME = `${BASE_URL}/orders/available-times`;
export const ORDER_GET_AVAILABLE_TIME_CALCULATOR = `${BASE_URL}/orders/available-times-calculator`;

export const ORDER_UPDATE_PAYMENT = `${ORDER_AUTH_URL}/:orderId/update-payment`
export const GET_ORDER_BY_NUMBER = `${ORDER_AUTH_URL}/:order_number/review-sms`